<template>
    <v-textarea
        :label="$t('instance.data_model.form_editor.fields_types.text_area_field.default_field')"
        :value="valueCopy"
        :rules="rules"
        :disabled="readOnly"
        @change="emitValue"
    ></v-textarea>
</template>

<script>

import FieldMixin from './field-mixin.vue';
export default {
    mixins: [FieldMixin],
    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {
        rulesList (){
            return {
                url: this.formActive ?[v => !v || this.urlRegex.test(v) || this.$t('instance.data_model.form_editor.fields_types.text_area_field.rules.url')]: [],
                txt: [],
            };
        },

        urlRegex (){
            return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
        }
    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/txt-area-field.vue